import React, {useEffect, useState} from 'react';
import dayjs from 'dayjs';
import { getReporting } from '../../api/reporting';
import MultiLineChart from '../../components/MultiLineChart';
import { Box, TextField } from '@mui/material';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const ByNetworkChart = ({ symbol }) => {

    // read from and to from url query params, they are timestamps
    const urlParams = new URLSearchParams(window.location.search);
    const from = urlParams.get('from');
    const to = urlParams.get('to');

    // convert to dayjs object from timestamp
    const from_date = from ? dayjs.unix(from) : dayjs().subtract(1, 'month');
    const to_date = to ? dayjs.unix(to) : dayjs();

    const [data, setData] = useState([]);
    const [config, setConfig] = useState({
        dimension: 'liquidity_rate',
        granularity: 'day',
        from: from_date,
        to: to_date,
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchData();
    }, [config]);

    const fetchData = () => {
        setIsLoading(true);
        getReporting({
            token_symbols: [symbol],
            from: config.from,
            to: config.to,
            group_by: ["token_symbol", "network"],
            granularity: config.granularity,
            dimension: config.dimension,

        }).then((data) => {
            setData(data.map((record) => {
                return {
                    x: record.timestamp * 1000,
                    y: record.average / (10 ** 25),
                    prefix: record.network,
                    suffix: '%',
                    network: record.network,
                }
            }));
            setIsLoading(false);
        });
    }

    const handleChange = (key, value) => {
        setConfig((prev) => ({
            ...prev,
            [key]: value,
        }));
    }

    const handleDateChange = (type, date) => {
        // update url query params
        const timestamp = date.unix();
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set(type, timestamp);
        window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
        handleChange(type, date);
    };
    

    const mapByNetwork = {}

    data.forEach((record) => {
        const key = record.network;
        if (!mapByNetwork[key]) {
            mapByNetwork[key] = [];
        }
        mapByNetwork[key].push(record);
    })

    const lines = Object.entries(mapByNetwork).map(([network, data]) => {
        return {
            data,
            key: network,
            label: network,
        }
    });

    return (
        <Box>
        <Box sx={{
        width: '100%', 
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'center', 
        alignItems: 'center', 
        mb: 2, 
        gap: 2, 
        backgroundColor: 'var(--background-color)',
        pt: 2,
        pb: 1,
        }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                sx={{marginTop: 2}}
                label="From Date"
                value={config.from}
                onChange={(newValue) => handleDateChange('from', newValue)}
                renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
                />
                <DatePicker
                sx={{marginTop: 3}}
                label="To Date"
                value={config.to}
                onChange={(newValue) => handleDateChange('to', newValue)}
                renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
                />
            </LocalizationProvider>
        </Box>
            <MultiLineChart
            lines={lines}
            isLoading={isLoading}
            />
        </Box>
    )
}

export default ByNetworkChart;